import { render, staticRenderFns } from "./Dialogs.vue?vue&type=template&id=9f830b9c&lang=pug&"
import script from "./Dialogs.vue?vue&type=script&lang=js&"
export * from "./Dialogs.vue?vue&type=script&lang=js&"
import style0 from "./Dialogs.vue?vue&type=style&index=0&id=9f830b9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports